import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import apiConfig from "../config/apiConfig";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Input,
  Button,
  FormGroup,
  Label,
  Form,
} from "reactstrap";

function TicketsCounseling() {
  const [ticketList, setTicketList] = React.useState([]); // لیست تیکت‌ها
  const [ticketMessages, setTicketMessages] = React.useState([]); // لیست پیام‌های تیکت
  const [loading, setLoading] = React.useState(true); // وضعیت بارگذاری
  const serverUrl = apiConfig.serverUrl;

  const [searchTerm, setSearchTerm] = useState(""); // مقدار وارد شده در جستجو
  const [users, setUsers] = useState([]); // لیست کاربران جستجو شده
  const [selectedUser, setSelectedUser] = useState(null); // کاربر انتخاب‌شده
  const [supportType, setSupportType] = useState(""); // نوع پشتیبانی
  const [message, setMessage] = useState(""); // متن پیام
  const [loading2, setLoading2] = useState(false); // وضعیت بارگذاری

  const [refresh, setRefresh] = React.useState(false);


  const handleSearch = () => {
    setLoading2(true);
    axios
      .get(`${serverUrl}users-search-panel`, {
        params: {
          query: searchTerm, // ارسال پارامتر جستجو
        },
      })
      .then((response) => {
        setUsers(response.data); // لیست کاربران جستجو شده
        setLoading2(false);
      })
      .catch((error) => {
        console.error("خطا در جستجو:", error);
        setLoading2(false);
      });
  };  
  
  const closeTicket = (ticketId) => {
    
    Swal.fire({
      title: "آیا از بستن این تیکت مطمئن هستید؟",
      text: "پس از بستن، امکان بازگرداندن آن وجود ندارد!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "بله، ببند",
      cancelButtonText: "خیر",
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("ticket_id", ticketId);
        formData.append("source", 'SubAppTicket');
  
        axios
          .post(`${serverUrl}close-ticket-panel`, formData)
          .then(() => {
            Swal.fire("بسته شد!", "تیکت با موفقیت بسته شد.", "success");
            setRefresh((prev) => !prev); // مقدار refresh رو تغییر بده تا useEffect اجرا بشه
          })
          .catch((error) => {
            Swal.fire("خطا!", "مشکلی پیش آمده، دوباره تلاش کنید.", "error");
          });
      }
      
    });
  };
  
  const handleSendMessage = () => {
    if (!selectedUser || !supportType || !message) {
      toast.error('لطفاً تمام فیلدها را پر کنید.')
     
      return;
    }
  
    const formData = new FormData();
    formData.append("sender_id", 1);
    formData.append("sender_type", 'support');
    formData.append("receiver_id", selectedUser.id);
    formData.append("receiver_type", 'user');
    formData.append("support_type", supportType);
    formData.append("message", message);
    formData.append("source", selectedUser.app_type === 'sub_app' ? 'SubAppTicket' : 'Ticket');
  
    axios
      .post(`${serverUrl}create-ticket-panel`, formData, {
       
      })
      .then(() => {
        toast.success('پیام با موفقیت ارسال شد!');
        
        setSelectedUser(null);
        setSupportType("");
        setMessage("");
        setUsers([]);
        setSearchTerm("");
      })
      .catch((error) => {
        console.error("خطا در ارسال پیام:", error);
        alert("ارسال پیام با خطا مواجه شد.");
      });
  };
  
  // محاسبه پیام‌های خوانده‌نشده برای هر تیکت (با توجه به آرایه چندبعدی)
  const calculateUnreadMessages = (ticketId) => {
    // فیلتر کردن پیام‌ها برای تیکت با ticket_id معین
   
    const messagesForTicket = ticketMessages.find(
      (messages) => messages.some((msg) => msg.ticket_id == ticketId)
    );
    

    // اگر پیام‌هایی برای تیکت وجود داشته باشد، تعداد پیام‌های خوانده‌نشده را محاسبه می‌کنیم
    if (messagesForTicket) {
      return messagesForTicket.filter((msg) => msg.status === "not_seen")
        .length;
    }
    
    // اگر پیام‌ها برای تیکت پیدا نشد، مقدار 0 را برمی‌گردانیم
    return 0;
  };

  React.useEffect(() => {
    axios
      .get(serverUrl + "get-tickets-counseling-panel")
      .then((response) => {
        setTicketList(response.data.ListTicket); // تنظیم داده‌ها از "ListTicket"
        setTicketMessages(response.data.TicketMessages); // تنظیم داده‌ها از "TicketMessages"
        setLoading(false); // پایان بارگذاری
      })
      .catch((error) => {
        console.error("خطا در دریافت اطلاعات:", error);
        setLoading(false); // پایان بارگذاری حتی در صورت خطا
      });
  }, [refresh]);

  return (
    <>
    <ToastContainer /> 
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle style={{ textAlign: "right" }} tag="h4">
                صندوق پیام
                </CardTitle>
              </CardHeader>
              <CardBody>

                 {/* جستجوی کاربران */}
                <Form>
                  <Row>
                    <Col md="8">
                      <FormGroup>
                        <Label>جستجوی کاربر</Label>
                        <Input
                          type="text"
                          placeholder="نام یا ایمیل کاربر را وارد کنید..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          style={{ borderColor: "#2a6df6" }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="4" className="d-flex align-items-center">
                      <Button color="primary" onClick={handleSearch} block>
                        جستجو
                      </Button>
                    </Col>
                  </Row>
                </Form>
                <br/>
               
        {loading2 ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>در حال جستجو...</div>
        ) : users.length > 0 ? (
          <ul style={{ listStyle: "none", padding: "0", marginTop: "20px" }}>
            {users.map((user) => (
              <li
                key={user.id}
                onClick={() => setSelectedUser(user)}
                style={{
                  padding: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  marginBottom: "10px",
                  cursor: "pointer",
                  backgroundColor: selectedUser?.id === user.id ? "#2a6df6" : "#fff",
                  color: selectedUser?.id === user.id ? "#fff" : "#000",
                }}
              >
                {user.name} ({user.email})
              </li>
            ))}
          </ul>
        ) : null}
        {/* وارد کردن عنوان تیکت */}
{selectedUser && (
  <div style={{ marginTop: "20px" }}>
    <h5 style={{ textAlign: "right" }}>عنوان تیکت را وارد کنید</h5>
    <Input
      type="text"
      placeholder="عنوان تیکت را وارد کنید..."
      value={supportType} // از این مقدار برای عنوان تیکت استفاده کن
      onChange={(e) => setSupportType(e.target.value)}
      style={{ borderColor: "#2a6df6", marginBottom: "10px" }}
    />
  </div>
)}
        {/* نوشتن پیام */}
        {supportType && (
          <FormGroup style={{ marginTop: "20px" }}>
            <Label>پیام</Label>
            <Input
              type="textarea"
              placeholder="متن پیام خود را وارد کنید..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              style={{ height: "150px", borderColor: "#2a6df6" }}
            />
          </FormGroup>
        )}
        {/* دکمه ارسال */}
        {message && (
          <Button color="primary" block onClick={handleSendMessage}>
            ارسال پیام
          </Button>
        )}
 <br/>

                {loading ? (
                  <div style={{ textAlign: "center" }}>در حال بارگذاری...</div>
                ) : ticketList.length === 0 ? (
                  <div style={{ textAlign: "center" }}>هیچ تیکتی یافت نشد.</div>
                ) : (
                  <div>



<Table className="tablesorter" style={{ textAlign: "right" }}>
  <thead className="text-primary">
    <tr>
      <th>ردیف</th>
      <th>نام و نام خانوادگی</th>
      <th>عنوان</th>
      <th>وضعیت</th>
      <th>تاریخ</th>
      <th>ساعت</th>
      <th>منبع</th>
      <th>مشاهده</th>
      <th>عملیات</th> {/* ستون عملیات برای دکمه بستن تیکت */}
    </tr>
  </thead>
  <tbody>
    {ticketList.map((ticket, index) => {
      const unreadCount = calculateUnreadMessages(ticket.ticket_id);
      const isDisabled = ticket.source === "Ticket"; // بررسی اینکه آیا دکمه غیرفعال است

      return (
        <tr key={index} style={{ position: "relative" }}>
          <td>
            {index + 1}
            {unreadCount > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "0px",
                  right: "-20px",
                  background: "#2a6df6",
                  color: "white",
                  borderRadius: "50%",
                  width: "22px",
                  height: "22px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                }}
              >
                {unreadCount}
              </span>
            )}
          </td>
          <td>{`${ticket.name} ${ticket.last_name}`}</td>
          <td>{ticket.ticket_title}</td>
          <td>
            <p style={{ color: ticket.status == "closed" ? "red" : "inherit" }}>

                      {ticket.status == "open" ? "باز" : ticket.status == "closed" ? "بسته" : ticket.status}
            </p>
</td>

          <td>{ticket.date}</td>
          <td>{ticket.time}</td>
          <td style={{ textAlign: "right" }}>
            <span
              style={{
                display: "inline-block",
               
                color: ticket.source === "Ticket" ? "green" : "blue",
              }}
            >
              {ticket.source === "Ticket" ? "کاربر رژیم" : "کاربر مشاوره"}
            </span>
          </td>
          <td>
          <Link
              to="/rtl/rtl-ticket-messages"
              state={{ ticketid: ticket.ticket_id, source: ticket.source }} // ارسال منبع تیکت
              className="btn btn-info btn-sm"
              style={{ color: "white" }}
            >
              مشاهده
            </Link>

          </td>
          <td>
  <button
    className="btn btn-sm"
    onClick={() => !isDisabled && closeTicket(ticket.ticket_id)}
    disabled={isDisabled}
    style={{
      background: isDisabled ? "#6c757d" : "#dc3545",
      color: "white",
      border: "none",
      opacity: isDisabled ? 0.5 : 1,
      cursor: isDisabled ? "not-allowed" : "pointer",
    }}
  >
    بستن تیکت
  </button>
</td>
        </tr>
      );
    })}
  </tbody>
</Table>





                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default TicketsCounseling;




